import styled, { css } from 'styled-components';
import { select } from '../../../core/themev2';
import { getColor } from '../../../core/themev3';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    text-align: left;
    white-space: normal;
    margin-bottom: 4px;
  }
  .subtitle {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: left;
    white-space: normal;
  }
  .subtitle-user {
    width: 100%;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .form-title {
    width: 100%;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: left;
    margin-top: 4px;
  }
  .form-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ device }) => (device === 'tablet' ? '26px' : '16px')};
    div:first-child {
      margin-top: 0px;
    }
  }
  .inputBranch {
    display: flex;
    flex-direction: column;
    gap: 4px;
    .ctaSetInput {
      font-family: Hind;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 130%;
      color: ${select('blue')};
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
  .confirmData {
    width: 100%;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: ${({ device }) => (device === 'desktop' ? 'normal' : '26px')};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 3px;
    white-space: break-spaces;
    margin-top: ${({ device }) => (device === 'tablet' ? '28px' : '0')};
  }
`;

const InputFormContainer = styled.div`
  margin: 4px 0;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  label {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const InputContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  position: relative;
  .numberInput {
    width: 100%;
    .errorMessage {
      color: ${select('feedbackRed')};
      font-family: Hind;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      display: block;
      margin-top: 4px;
      white-space: break-spaces;
    }
  }
`;

const Input = styled.input.attrs(({ type, autoComplete }) => ({
  type: type || 'tel',
  autocomplete: autoComplete
}))`
  width: 100%;
  height: 48px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  border: 1px solid ${select('black')};
  padding: 4px 32px 4px 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: ${({ disabled }) => disabled && select('neutralDarkGray')};
  :focus {
    border-color: ${({ validBorder }) => (validBorder === 'isNotValid' ? select('feedbackRed') : getColor('primary'))};
  }
  border-color: ${({ validBorder }) => select(validBorder === 'isNotValid' ? 'feedbackRed' : 'black')};
`;

const ValidIcon = styled.img`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 4px;
  top: 4px;
  margin: 8px;
`;

const CTA = styled.button.attrs(({ type }) => ({
  type: type || 'button'
}))`
  height: 48px;
  width: 100%;
  border-radius: 8px;
  color: ${select('midNeutralGray')};
  background-color: ${select('neutralGray')};
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  text-align: center;
  margin-top: ${({ marginTop }) => marginTop};
  padding: 0 12px;
  cursor: auto;
  ${({ enabled }) =>
    enabled &&
    css`
      background-color: ${getColor('primary')};
      color: ${select('white')};
      cursor: pointer;
      :hover {
        background-color: ${getColor('secondary')};
      }
    `};
  &.borderButton {
    background-color: ${select('white')};
    color: ${select('black')};
    border: 1px solid ${getColor('primary')};
    max-width: 100%;
    &:hover {
      border-color: ${getColor('tertiary')};
    }
  }
  &.noBorderButton {
    background-color: ${select('white')};
    color: ${select('black')};
    max-width: 100%;
    font-weight: 600;
    &:hover {
      background-color: ${select('neutralGray')};
    }
  }
`;

const Option = styled.div`
  width: 100%;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${select('black')};
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 4px 4px 4px 8px;
  cursor: pointer;
  :hover {
    background-color: ${select('neutralGray')};
    color: ${select('black')};
    font-weight: 600;
  }
`;

const TooltipText = styled.div`
  padding: 8px 6px;
  width: 220px;
  white-space: pre-wrap;
  text-align: start;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgb(256, 256, 256, 0.6);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
`;

export {
  Container,
  InputFormContainer,
  LabelContainer,
  InputContainer,
  Input,
  CTA,
  Option,
  TooltipText,
  ValidIcon,
  LoaderWrapper
};
